import {ProductGroup} from 'app/blocks/model/product-group.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IProductGroup} from 'app/blocks/model/product-group.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class ProductGroupService extends EntityCrudService<IProductGroup> {
    constructor(http: HttpClient) {
        super(http, Resource.PRODUCT_GROUPS, (obj?) => new ProductGroup(obj));
    }
}
